var quantity = document.querySelector("product-info .product-form__quantity");

if (quantity) {
  let limitedText = quantity.querySelector(".limited_quantity_text");
  let input = quantity.querySelector("input");
  
  applyStyle();

  input?.addEventListener("change", () => {
    applyStyle();
  })

  function applyStyle () {
    let isMax = Number(input?.getAttribute("max")) - Number(input?.value) == 0;
    if (isMax) {
      limitedText.style.display = "block";
    } else {
      limitedText.style.display = "none";
    }
  }
}